import type * as Actions from './actions';
import {
  loadAlertSettingFailed,
  loadAlertSettingRequest,
  loadAlertSettingSucceeded,
  loadDeviceStatusSubscriptionFailed,
  loadDeviceStatusSubscriptionSucceeded,
  updateAlertSettingEnd,
  updateDeviceStatusSubscriptionEnd,
} from './actionCreators';
import { ActionTypes } from './actionTypes';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import type { DeviceStatusSubscription } from '@cobliteam/common-types';

import { GraphQLUserAlertSettingsRequester, type UserAlertSettings } from '@cobliteam/api-lib';
import { GraphQLDeviceStatusSubscriptionRequester } from '@cobliteam/api-lib/src/dashboard/userAlert/deviceStatusSubscription';

import Alert from '@cobliteam/ui/components/Alert';

const notificationsRequester = new GraphQLUserAlertSettingsRequester();
const subscriptionRequester = new GraphQLDeviceStatusSubscriptionRequester();

export function* loadAlertSettingRequestSaga(_: Actions.LoadAlertSettingRequest) {
  try {
    const settings: UserAlertSettings[] = yield call(notificationsRequester.getSettings);
    yield put(loadAlertSettingSucceeded(settings));
  } catch (err) {
    Alert.error('Houve um erro, tente novamente mais tarde.');
    yield put(loadAlertSettingFailed());
  }
}

export function* updateAlertSettingRequestSaga(action: Actions.UpdateAlertSettingRequest) {
  const newSettings = action.payload;
  const callMethod = newSettings.id ? notificationsRequester.updateSettings : notificationsRequester.insertSettings;

  try {
    yield call(callMethod, newSettings);
    Alert.success('Notificação atualizada');
  } catch (err) {
    Alert.error('Houve um erro, tente novamente mais tarde.');
  } finally {
    yield put(updateAlertSettingEnd());
    yield put(loadAlertSettingRequest());
  }
}

export function* loadDeviceStatusSubscriptionSaga(_: Actions.LoadDeviceStatusSubscriptionRequest) {
  try {
    const subscription: DeviceStatusSubscription = yield call(subscriptionRequester.getSubscription);
    yield put(loadDeviceStatusSubscriptionSucceeded(subscription));
  } catch (err) {
    Alert.error('Houve um erro, tente novamente mais tarde.');
    yield put(loadDeviceStatusSubscriptionFailed());
  }
}

export function* updateDeviceStatusSubscriptionSaga(action: Actions.UpdateDeviceStatusSubscriptionRequest) {
  const subscription = action.payload;

  try {
    yield call(subscriptionRequester.updateSubscription, subscription);
    Alert.success('Configurações de notificação atualizadas!');
  } catch (err) {
    Alert.error('Houve um erro, tente novamente mais tarde.');
  } finally {
    yield put(updateDeviceStatusSubscriptionEnd());
  }
}

export function* UserAlertSettingSagasListener() {
  yield all([
    takeLatest(ActionTypes.LOAD_ALERT_SETTING_REQUEST, loadAlertSettingRequestSaga),
    takeLatest(ActionTypes.UPDATE_ALERT_SETTING_REQUEST, updateAlertSettingRequestSaga),
    takeLatest(ActionTypes.LOAD_DEVICE_STATUS_SUBSCRIPTION_REQUEST, loadDeviceStatusSubscriptionSaga),
    takeLatest(ActionTypes.UPDATE_DEVICE_STATUS_SUBSCRIPTION_REQUEST, updateDeviceStatusSubscriptionSaga),
  ]);
}
